import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Gift, ShieldCheck, Sparkles, Star } from 'lucide-react';
export const MidPagePricing = () => {
  return <section id="mid-pricing" className="relative overflow-hidden bg-gradient-to-br from-terracotta to-[#d6761b] px-4 py-16 text-white md:py-24 lg:px-8" data-id="element-124">
      {/* Decorative background elements */}
      <div className="absolute -left-20 -top-20 h-64 w-64 rounded-full bg-white/10 blur-3xl" data-id="element-125" />
      <div className="absolute -right-20 -bottom-20 h-80 w-80 rounded-full bg-yellow-400/20 blur-3xl" data-id="element-126" />

      <div className="mx-auto max-w-6xl relative z-10" data-id="element-127">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center" data-id="element-128">
          {/* Left Column: Value Stack */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-129">
            <div className="inline-flex items-center rounded-full bg-white/20 px-4 py-1.5 text-sm font-bold uppercase tracking-wider text-white backdrop-blur-sm border border-white/30" data-id="element-130">
              <Sparkles className="mr-2 h-4 w-4 text-yellow-300" data-id="element-131" />
              Oferta por Tiempo Limitado
            </div>

            <h2 className="font-serif text-4xl font-bold leading-tight md:text-5xl lg:text-6xl" data-id="element-132">
              Tu libertad cuesta menos que un café y un postre
            </h2>

            <div className="space-y-4 text-lg text-white/90 md:text-xl" data-id="element-133">
              <p data-id="element-134">
                Podrías seguir gastando 30 dólares cada vez que el cansancio te
                obliga a pedir comida a domicilio. Podrías seguir perdiendo 2
                horas cada tarde picando cebolla mientras tus hijos crecen sin
                ti en la otra habitación.
              </p>
              <p className="font-bold text-white" data-id="element-135">
                O puedes tomar la llave de tu libertad hoy mismo.
              </p>
            </div>
          </motion.div>

          {/* Right Column: Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-136">
            {/* Floating Badge */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -right-4 -top-6 z-20 rotate-12 rounded-full bg-yellow-400 px-6 py-3 font-bold text-terracotta shadow-xl md:-right-8 md:-top-8 md:text-xl border-2 border-white" data-id="element-137">
              AHORRA 88%
            </motion.div>

            <div className="rounded-3xl bg-white p-8 text-center shadow-2xl md:p-12" data-id="element-138">
              <div className="mb-2 flex justify-center" data-id="element-139">
                <div className="flex space-x-1" data-id="element-140">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-5 w-5 fill-yellow-400 text-yellow-400" data-id="element-141" />)}
                </div>
              </div>
              <p className="mb-6 text-sm font-medium text-gray-500" data-id="element-142">
                Más de 5,000 familias felices confían en nosotros
              </p>

              <div className="mb-8 space-y-2" data-id="element-143">
                <p className="text-xl font-medium text-gray-400 line-through decoration-red-400 decoration-2" data-id="element-144">
                  Valor Total: $148
                </p>
                <div className="flex items-center justify-center space-x-2" data-id="element-145">
                  <span className="font-serif text-6xl font-bold text-terracotta md:text-7xl" data-id="element-146">
                    $9.98
                  </span>
                  <span className="text-left text-sm font-medium text-gray-500 leading-tight" data-id="element-147">
                    PAGO
                    <br data-id="element-148" />
                    ÚNICO
                  </span>
                </div>
              </div>

              <motion.a href="https://pay.hotmart.com/N104374094F?off=ioa7b18h&checkoutMode=10" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="group relative mb-6 inline-flex w-full items-center justify-center overflow-hidden rounded-full bg-terracotta px-8 py-5 text-xl font-bold text-white shadow-lg transition-all hover:bg-[#d6761b] hover:shadow-xl" data-id="element-149">
                <span className="relative z-10 flex items-center" data-id="element-150">
                  ¡SÍ, QUIERO MI PROTOCOLO DE CENAS DE PAZ POR $9.98!
                  <ArrowRight className="ml-2 h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-151" />
                </span>
                <div className="absolute inset-0 -z-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 transition-opacity group-hover:animate-shimmer" data-id="element-152" />
              </motion.a>

              <div className="flex items-center justify-center space-x-2 text-sm font-medium text-sage" data-id="element-153">
                <ShieldCheck className="h-5 w-5" data-id="element-154" />
                <span data-id="element-155">Garantía de Devolución de 30 Días</span>
              </div>

              <p className="mt-6 text-xs text-gray-400" data-id="element-156">
                Descarga digital instantánea. Pago seguro.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};